<template>
  <div v-if="validData">
    <span @click="activateDialog" class="buttonOverrideSpan" v-if="!openPopupDirectly">
      <slot name="buttonOverride">
        <el-button
          :type="usePrimaryClassOnly || !isQuantityAllZero && !lowerQuantity ? 'primary' : ''"
          :class="buttonClass"
          :disabled="disabled"
          >
          <slot>Naroči</slot>
        </el-button>
      </slot>
    </span>
    <el-dialog
      :width="'530px'"
      append-to-body
      :visible.sync="potrdiPopup"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      custom-class="orderButtonConfirmDialog odmikDialoga"
    >
      <template v-slot:title>
        <div style="text-align: center;" class="mt-3">
          <img src="/static/img/MojT2/Eposlovanje/Icon-feather-alert-circle.png" style="width: 100px; height: 100px;" />
        </div>
      </template>
      <div style="text-align: center">
        <div v-html="notifyText" class="mb-5 dialogText"></div>
        <slot name="additionalDataInputs"/>
        <div class="d-flex" style="flex-direction: column; align-items: center;">
          <el-button
            :disabled="anyAdditionalDataEmpty"
            @click="onlyModifyFreeService ? modifyFreeService() : popupOpen = true"
            type="primary"
            class="gumb-potrdi uppercase"
            style="width:250px;"
          >
            {{notifyButton}}
          </el-button>
          <el-button
            @click="potrdiPopup = false; $emit('orderCanceled')"
            class="gumb-crni-okvir uppercase"
            style="width:250px; margin-left: 0px; border: 0px;"
          >
            Prekliči
          </el-button>
        </div>
      </div>

    </el-dialog>
    <sprememba-storitev-popup
      v-if="popupOpen"
      :services="services"
      :serviceName="serviceName"
      :lowerQuantity="lowerQuantity"
      @zapriPopup="zaprtjePopupa()"
      @orderConfirmed="$emit('orderConfirmed')"
    />
  </div>
</template>

<script>
import SpremembaStoritevPopup from '../Dashboard/Views/Naroci/SpremembaStoritevPopup.vue'
import {Button, Dialog, Icon} from 'element-ui'
import Order from '../../assets/js/Order/Order'
import Validacija from '../../assets/js/globalne_funkcije/Validacija'

export default {
  name: 'OrderButton',
  components: {
    SpremembaStoritevPopup,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Icon.name]: Icon
  },
  emits: ['orderConfirmed', 'orderCanceled', 'popupClosed', 'modifyFreeService'],
  props: {
    usePrimaryClassOnly: {
      type: Boolean,
      default: false
    },
    serviceName: {
      type: String,
      required: true
    },
    services: {
      type: Array,
      default: () => []
    },
    trzniPaketNovi: {
      type: Boolean,
      default: false
    },
    trzniPaketSprememba: {
      type: Boolean,
      default: false
    },
    newOrder: {
      type: Boolean,
      default: true
    },
    lowerQuantity: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    openPopupDirectly: {
      type: Boolean,
      default: false
    },
    onlyModifyFreeService: {
      type: Boolean,
      default: false
    },
    customNotifyText: {
      type: String,
      default: ''
    },
    customNotifyTextButton: {
      type: String,
      default: ''
    },
    customNotifyTextButtonRemove: {
      type: String,
      default: ''
    }
  },
  computed: {
    buttonClass () {
      return !this.isQuantityAllZero && !this.lowerQuantity ? 'gumb-potrdi orderButton' : 'gumb-crni-okvir orderButton'
    },
    isQuantityAllZero () {
      let out = true
      this.services.forEach((service) => {
        if (service.quantity > 0) {
          out = false
        }
      })
      return out
    },
    notifyTitle () {
      let out = 'Naročilo samostojna storitev'
      if (this.trzniPaketNovi) {
        out = 'Naročilo tržnega paketa'
      }
      if (this.trzniPaketSprememba) {
        out = 'Sprememba tržnega paketa'
      }
      if (this.isQuantityAllZero) {
        out = 'Odjava samostojna storitev'
      }
      return out
    },
    notifyText () {
      if (this.customNotifyText !== '') {
        return this.customNotifyText
      }
      let orderTypeWord = this.onlyModifyFreeService && !this.isQuantityAllZero ? 'ustvariti ' : 'naročiti '
      let out = 'Ste prepričani, da želite ' + orderTypeWord + this.serviceName + '?'
      if (this.trzniPaketSprememba) {
        out = 'Z oddajo naročila spreminjate naročen tržni paket.<br/><br/>' +
          'Morebitne dodatne storitve, ki so bile del prejšnjega paketa aktivne, bodo ostale še naprej naročene. ' +
          'V primeru, da ste izbrali nižji paket, se bo le-ta vklopil s 1. v naslednjem mesecu.<br/><br/>' +
          'Spremembe posameznih TV ali mobilnih paketov lahko uredite v meniju "Naroči".'
      }
      if (this.isQuantityAllZero || this.lowerQuantity) {
        out = 'Ste prepričani, da želite odjaviti ' + this.serviceName + '?'
      }
      return out
    },
    notifyButton () {
      if (this.onlyModifyFreeService && !this.isQuantityAllZero) {
        return 'Potrdi izbiro'
      }
      let out = this.customNotifyTextButton !== '' ? this.customNotifyTextButton : 'Da, želim naročiti'
      if (this.trzniPaketSprememba) {
        out = 'Strinjam se'
      }
      if (this.isQuantityAllZero || this.lowerQuantity) {
        out = this.customNotifyTextButtonRemove === '' ? 'Da, želim odjaviti' : this.customNotifyTextButtonRemove
      }
      return out
    }
  },
  data () {
    return {
      anyAdditionalDataEmpty: false,
      popupOpen: false,
      validData: false,
      potrdiPopup: false,
      order: new Order(),
      validacija: null
    }
  },
  mounted () {
    if (this.openPopupDirectly) {
      this.activateDialog()
    }
  },
  methods: {
    async modifyFreeService () {
      this.potrdiPopup = false
      this.$emit('modifyFreeService')
    },
    zaprtjePopupa () {
      this.popupOpen = false
      this.potrdiPopup = false
      this.$emit('popupClosed')
    },
    activateDialog () {
      if (this.services.length !== 0) {
        this.potrdiPopup = true
      } else {
        let paramObvestilo = {}
        paramObvestilo.message = 'Nobenih sprememb ni bilo vnešenih. Prosimo, preverite in poskusite ponovno.'
        this.ShowWarningMessage(paramObvestilo)
      }
    },
    validateServices (arr) {
      if (!Array.isArray(arr)) {
        return false
      }
      for (let i = 0; i < arr.length; i++) {
        if (
          typeof arr[i] !== 'object' ||
          typeof arr[i].serviceId !== 'number' ||
          typeof arr[i].quantity !== 'number'
        ) {
          return false
        }
        if (
          (arr[i].terminationPointId === null || arr[i].terminationPointId === undefined) &&
          (arr[i].customerId === null || arr[i].customerId === undefined)
        ) {
          return false
        }
        if (Array.isArray(arr[i].additionalData)) {
          for (let j = 0; j < arr[i].additionalData.length; j++) {
            if (typeof arr[i].additionalData[j].value === 'string' && arr[i].additionalData[j].value === '') {
              this.anyAdditionalDataEmpty = true
            }
            if (typeof arr[i].additionalData[j].key === 'undefined' || typeof arr[i].additionalData[j].value === 'undefined') {
              return false
            }
            if (arr[i].additionalData[j].key === 'email' && !this.validacija.EmailValid(arr[i].additionalData[j].value)) {
              this.anyAdditionalDataEmpty = true
            }
          }
        }
      }
      return true
    }
  },
  watch: {
    services: {
      immediate: true,
      handler (s) {
        this.anyAdditionalDataEmpty = false
        if (this.validacija === null) {
          this.validacija = new Validacija()
        }
        this.validData = this.validateServices(s)
        if (!this.validData) {
          console.log('Napaka pri validaciji vhodnih parametrov')
        } else {
          this.order.parseServicesFromArrayOfObjects(s)
        }
      }
    }
  }
}
</script>

<style scoped>
.dialogText {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/OrderButton.vue